export const checkListInputStyles = {
  title: {
    marginBottom: 5,
    fontFamily: 'FSEmeric-Medium',
    // fontSize: 16,
    '&+*': { marginTop: 0, width: '100%' },
  },
}
